import React from 'react';
import axios from 'axios';
import { Card, Button, Avatar,Modal,Spin,Form,Input,Select,message } from 'antd';
import AccountUpdateForm from './AccountUpdateForm'
import { UserOutlined,LoadingOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import { Drawer,Divider } from 'antd';
import * as serverconfig from '../serverconn'
import {
  Col,
  Row,
} from 'reactstrap';
var CryptoJS = require("crypto-js");


const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const FormItem=Form.Item;
const { Option } = Select;
const { TextArea } = Input;


var token= ''
var bizuserid=''


class CompleteAction extends React.Component{

    state={
        account: {},
        datarequested:true,
        applicant_action:{},
        required_fields:[],
        submitted_data:[],
        actionID:'',
        remarks:''
    }

    componentDidMount(){
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }

      if(localStorage.getItem("bizuserid")){
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      }else{
        bizuserid= ''
      }

  
      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

        const action_ID=this.props.match.params.actionID;
        this.setState({actionID:action_ID})
        axios.get(`${serverconfig.backendserverurl}/api/applicant_actions/${action_ID}`)
        .then(res => {  
            this.setState({
              applicant_action: res.data
            })



        })
        this.setState({datarequested:false})

     }

      //sample exists
      isitem_added = (item_name, list) => {
        return list.some((item) => item.label === item_name);
      };
  


    render(){

      if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin  size="large">
                <div className="content" />
              </Spin>     
          </div>
        )
  
      }else{
        return(
          <div>
            <Card 
              style={{padding:10}}
              hoverable>
              <h3>Review & complete this Action.</h3>


                    <FormItem label="Remarks">
                        <TextArea
                            placeholder="Remarks"
                            autoSize={{ minRows: 2, maxRows: 6 }}
                            value={this.state.remarks}
                            onChange={(val)=>{this.setState({remarks:val.target.value})}}
                        />
                    </FormItem>



                    <Form.Item>
                    <Button type="primary" htmlType="button" 
                    onClick={()=>{
                        let form_data = new FormData();
                        form_data.append('actionID', this.state.actionID);
                        form_data.append('remarks', this.state.remarks);
                        form_data.append('bizuserid', bizuserid);

                        //Register the account first
                        axios.post(serverconfig.backendserverurl+'/customqueries/admin_action_completion',form_data)
                        .then(res =>{
                        message.success(res.data.message)
                        this.setState({datarequested:false})
                        window.location.reload(false)
                
                        })
                        .catch(error => console.log(error))
                
                    }}>
                    Submit 
                    </Button>
                </Form.Item>
                    
            </Card>
          </div>
      )


      }
       
    }
}

export default CompleteAction; 